<template>
  <div>
    <PrintMajor />
  </div>
</template>

<script>
import PrintMajor from '@/components/DownLoadAndPrint/v1/Major.vue'

export default {
  components: { PrintMajor },

}
</script>
